module.exports = __webpack_public_path__ + "img/Diwali 4.3c6a2f0b.jpeg";